import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cross",
  "use": "icon-cross-usage",
  "viewBox": "0 0 39.76 39.03",
  "content": "<symbol viewBox=\"0 0 39.76 39.03\" id=\"icon-cross\">\r\n    <path d=\"M38.84,5.39,24,20.19l13,13a3.07,3.07,0,0,1-4.33,4.34l-13-13L6.12,38.1a3.15,3.15,0,0,1-4.46-4.46L15.24,20.06.9,5.73A3.07,3.07,0,0,1,5.24,1.39L19.58,15.73,34.37.93a3.16,3.16,0,0,1,4.47,4.46Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/cross.svg
// module id = ./app/general/svg/cross.svg
// module chunks = app